/* eslint-disable @next/next/no-img-element */
import styled from '@emotion/styled';
import {
  ButtonIconPrimaryMedium,
  TextCaption,
  token,
} from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';

import { css } from '@emotion/react';
import { Category } from '@modules/categories/categories.types';
import { useCurrentCategoryImage } from '@modules/category-images/category-images.store';
import { PUBLICATIONS_CATEGORY_FILTER } from '@modules/routes/constants';
import { SkeletonCategoriesListItem } from './SkeletonCategoriesListItem';

type CategoriesListItemProps = {
  category: Category;
};

export const CategoriesListItem = (props: CategoriesListItemProps) => {
  const { category } = props;
  const { data: categoryImage, isLoading } = useCurrentCategoryImage(
    category?.id as string,
  );

  if (isLoading) return <SkeletonCategoriesListItem />;

  return (
    <FlexColumn>
      <LinkWrapper
        href={PUBLICATIONS_CATEGORY_FILTER(category?.id)}
        key={category?.id}
      >
        <ButtonIconPrimaryMediumStyled>
          <Image src={categoryImage?.asset_url} />
        </ButtonIconPrimaryMediumStyled>
      </LinkWrapper>
      <TextCaption>{category?.name}</TextCaption>
    </FlexColumn>
  );
};

const gap = css`
  gap: ${token.spacing.spacingXSmall};
`;

const FlexColumn = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  max-width: 80px;
  min-width: 80px;
  padding: ${token.spacing.spacingXxSmall} 0;
  text-align: center;
  flex-direction: column;
  ${gap};
`;

const ButtonIconPrimaryMediumStyled = styled(ButtonIconPrimaryMedium)`
  box-shadow: ${token.shadows.shadowLevelMedium};
`;

const Image = styled.img`
  width: 24px;
  height: 24px;
`;
